function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.32.867L13.664.023a.793.793 0 00-.562.07.775.775 0 00-.387.387l-1.688 3.938a.877.877 0 00-.035.545.842.842 0 00.281.439l2.109 1.758a12.916 12.916 0 01-2.549 3.656 12.358 12.358 0 01-3.673 2.567l-1.723-2.11a.706.706 0 00-.457-.3.893.893 0 00-.527.053L.515 12.715a.757.757 0 00-.422.387.793.793 0 00-.07.563l.844 3.655a.667.667 0 00.281.492.89.89 0 00.527.176 16.045 16.045 0 008.227-2.215 16.39 16.39 0 005.871-5.871 16.045 16.045 0 002.215-8.226.89.89 0 00-.176-.527.667.667 0 00-.492-.282z",
  fill: "#8498a3"
});

var SvgIconTell = function SvgIconTell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.988,
    height: 17.988
  }, props), _ref);
};

export default SvgIconTell;